
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1301Dialog extends Serenity.EntityDialog<Report_1301Row, any> {
        protected getFormKey() { return Report_1301Form.formKey; }
        protected getIdProperty() { return Report_1301Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1301Row.localTextPrefix; }
        protected getNameProperty() { return Report_1301Row.nameProperty; }
        protected getService() { return Report_1301Service.baseUrl; }
        protected getDeletePermission() { return Report_1301Row.deletePermission; }
        protected getInsertPermission() { return Report_1301Row.insertPermission; }
        protected getUpdatePermission() { return Report_1301Row.updatePermission; }

        protected form = new Report_1301Form(this.idPrefix);

        

    }
}